import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Plus } from 'lucide-react';
import StaggeredAnimation from '../../components/ui/staggered-animation';

const SalesPipeline = () => {
  return (
    <div className="space-y-6">
      <StaggeredAnimation delay={100} animation="fadeUp">
        <div className="flex justify-between items-center">
          <div>
            <h1 className="text-3xl font-bold text-foreground">📈 Sales Pipeline</h1>
            <p className="text-muted-foreground">Deals, leads, stages with radar and kanban views</p>
          </div>
          <Button>
            <Plus className="mr-2 h-4 w-4" />
            New Deal
          </Button>
        </div>
      </StaggeredAnimation>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <StaggeredAnimation delay={200} animation="fadeUp">
          <Card>
            <CardHeader>
              <CardTitle>Pipeline Stages</CardTitle>
              <CardDescription>Deal progression overview</CardDescription>
            </CardHeader>
            <CardContent>
              <p className="text-muted-foreground">Kanban board will be displayed here...</p>
            </CardContent>
          </Card>
        </StaggeredAnimation>

        <StaggeredAnimation delay={200} animation="fadeUp" stagger={100}>
          <Card>
            <CardHeader>
              <CardTitle>Lead Sources</CardTitle>
              <CardDescription>Where your leads come from</CardDescription>
            </CardHeader>
            <CardContent>
              <p className="text-muted-foreground">Radar chart will be displayed here...</p>
            </CardContent>
          </Card>
        </StaggeredAnimation>

        <StaggeredAnimation delay={200} animation="fadeUp" stagger={200}>
          <Card>
            <CardHeader>
              <CardTitle>Conversion Funnel</CardTitle>
              <CardDescription>Lead to customer journey</CardDescription>
            </CardHeader>
            <CardContent>
              <p className="text-muted-foreground">Funnel visualization will be shown here...</p>
            </CardContent>
          </Card>
        </StaggeredAnimation>
      </div>
    </div>
  );
};

export default SalesPipeline;
